"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var errorLoad_1 = require("./errorLoad");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.NotificationInteractionEventNames.ErrorLoad] = errorLoad_1.errorLoadCreator,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
